import React, { useState, useEffect } from 'react';
import { Button, Modal, Form } from 'react-bootstrap';
import logo from "../../images/jm-logo.png";
import close from '../../images/close.png'
function SebiPopup(){
     // const [isPopupOpen, setIsPopupOpen] = useState('false');
     const [isPopupOpen, setIsPopupOpen] = useState(true);
     const [selectedOption, setSelectedOption] = useState('option2');
     const [isSubmitDisabled, setIsSubmitDisabled] = useState(false);
     const [shouldShowExitButton, setShouldShowExitButton] = useState(false);
     const [shouldShowSubmitButton, setShouldShowSubmitButton] = useState(true);

     const closePopup = () => {
        window.parent.close();
        setIsPopupOpen(false);
    };
    return (
        <div className='popupmod'>

            <Modal show={isPopupOpen}  className="modal modal-home ">
                <Modal.Header>
                    <div className='logo-img'>
                        <a href='/'><img src={logo} alt="JM_MutualFund Logo" className='img-fluid' /></a>
                    </div>
                    <button className=" model-sebi">
                           <img src={close}  onClick={closePopup} className="close-popup" alt='close-button'></img>
                           </button>
                </Modal.Header>
                <Modal.Body id="modal_info">
                    {/* <p className="modal_info"> The information contained in this website is not intended for any person who is a resident of the United States of America or a resident of any jurisdiction, the laws of which impose a prohibition on soliciting the securities business in that jurisdiction without going through the registration requirements and/or prohibit the use of any information contained on this website.</p> */}

                   <h5 className='text-bold'> NOTICE</h5>


<p className="modal_info scroll-contect">Investors are requested to note that on the occasion of Ram Temple Pran Prathishta ceremony, Monday, 
January 22, 2024 will be observed as a public holiday under Section 25 of the Negotiable Instruments Act, 
1881 and it will be a trading holiday for National Stock Exchange/BSE.
Further, Saturday, January 20, 2024 and Monday, January 22, 2024 will be a Non-Business day for all the 
Schemes of JM Financial Mutual Fund (“the Fund”).
Pursuant to above, it may be noted that no transactions will be accepted in any of the schemes of the Fund 
on the abovementioned dates.
Authorised Signatory
Place : Mumbai JM Financial Asset Management Limited
Date : January 20, 2024 (Investment Manager to JM Financial Mutual Fund)
For further details, please contact :
JM Financial Asset Management Limited <br/>
<strong>Registered Office:</strong> 7th Floor, Cnergy, Appasaheb Marathe Marg, Prabhadevi, Mumbai - 400025.<br/>
<strong>Corporate Office: </strong>Office B, 8th Floor, Cnergy, Appasaheb Marathe Marg, Prabhadevi, Mumbai-400025.<br/> 
<strong>Corporate Identity Number: </strong>U65991MH1994PLC078879.  Tel. No.: (022) 6198 7777 <br/>
Fax No.: (022) 6198 7704.  E-mail: investor@jmfl.com  Website : www.jmfinancialmf.com
Mutual Fund investments are subject to market risks, read all scheme 
related documents carefully. REF No. 40/2023-24
</p>
                  
                </Modal.Body>
                {/* <Modal.Footer>
             

                    {shouldShowExitButton && (
                        <Button variant="secondary" onClick={closePopup}>
                            Exit
                        </Button>
                    )}
                    {shouldShowSubmitButton && (
                        <Button variant="primary" onClick={handleSubmit} disabled={isSubmitDisabled}>
                            Submit
                        </Button>
                    )}
                </Modal.Footer> */}

            </Modal>
        </div>
    );
}
export default SebiPopup;